module.exports = __webpack_public_path__ + "static/media/vision_source_logo.43976d58.png";